










import { Component, Vue } from "vue-property-decorator";
import MessagesTable from "@/components/messages/MessagesTable.vue";
import GlobalFilterSensitiveMixin from "@/mixins/GlobalFilterSensitiveMixin";

@Component({
  components: {
    MessagesTable,
  },
  mixins: [GlobalFilterSensitiveMixin],
})
export default class Messages extends Vue {
  tab = 0;
}
